export const ActionErrorExtensions = {
  ACTION_TOO_MANY_TOTAL_REACTIONS: 'ACTION_TOO_MANY_TOTAL_REACTIONS',
  ACTION_TOO_MANY_UNIQUE_REACTIONS: 'ACTION_TOO_MANY_UNIQUE_REACTIONS',
} as const;
